import * as XLSX from 'xlsx';

function cellValue(value) {
  if (value == null) return '';
  if (value instanceof Date) return value;
  if (typeof value === 'object') return '';
  return value;
}

export function downloadWorkbook(filename, sheets) {
  const book = XLSX.utils.book_new();
  const list = Array.isArray(sheets) ? sheets : [{ name: 'Data', rows: sheets }];
  list.forEach((sheet, index) => {
    const rows = (sheet.rows || []).map((row) => {
      const out = {};
      Object.entries(row).forEach(([key, value]) => {
        out[key] = cellValue(value);
      });
      return out;
    });
    const name = String(sheet.name || `Sheet${index + 1}`).replace(/[\\/?*[\]:]/g, ' ').slice(0, 31) || 'Data';
    XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(rows), name);
  });
  const safe = String(filename || 'export').replace(/\.xlsx?$/i, '');
  XLSX.writeFile(book, `${safe}.xlsx`, { bookType: 'xlsx' });
}
